var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 43,
    viewBox: "0 0 25 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7935,
    cy: 27.7184,
    r: 9.53476,
    fill: "#EC6A32"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6496 32.1094L12.6996 29.0494L10.8246 32.1094H9.39958L12.0546 28.0294L9.39958 23.8894H10.9446L12.8946 26.9344L14.7546 23.8894H16.1796L13.5396 27.9544L16.1946 32.1094H14.6496Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXClose);
export default __webpack_public_path__ + "static/media/x_close.3913e3a1cf993eaf9bbf5c5b04cf468b.svg";
export { ForwardRef as ReactComponent };